import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["title", "html", "js", "css", "editors", "css_external", "js_external", "js_pre_processor"];
import React from 'react';

/**
 * CodePenOption Example
 * 
 * ```js
 * {
 *   title: `uiw${version} - demo`,
 *   editors: '0010',
 *   js_pre_processor: 'babel',
 *   html: '<div id="container" style="padding: 24px"></div>',
 *   js: jsxCode || '',
 *   css: '',
 *   css_external: `https://unpkg.com/uiw${version}/dist/uiw.min.css`,
 *   js_external: `https://unpkg.com/react@16.x/umd/react.development.js;https://unpkg.com/react-dom@16.x/umd/react-dom.development.js;https://unpkg.com/classnames@2.2.6/index.js;https://unpkg.com/uiw${version}/dist/uiw.min.js;https://unpkg.com/@uiw/codepen-require-polyfill@1.0.2/index.js`,
 * };
 * ```
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var defaultOptions = {
  editors: '0010',
  js_pre_processor: 'babel'
};
var codepen = props => {
  var _ref = props || {},
    {
      title,
      html,
      js,
      css,
      editors = defaultOptions.editors,
      css_external,
      js_external,
      js_pre_processor = defaultOptions.js_pre_processor
    } = _ref,
    other = _objectWithoutPropertiesLoose(_ref, _excluded);
  var codePenOption = {
    title,
    html,
    js,
    css,
    editors,
    css_external,
    js_external,
    js_pre_processor
  };
  return /*#__PURE__*/_jsxs("form", _extends({
    action: "https://codepen.io/pen/define",
    method: "POST",
    target: "_blank"
  }, other, {
    children: [/*#__PURE__*/_jsx("input", {
      type: "hidden",
      name: "data",
      value: JSON.stringify(codePenOption)
    }), /*#__PURE__*/_jsx("button", {
      type: "submit",
      children: props.children
    })]
  }));
};
export default codepen;